export default __webpack_public_path__ + "static/media/etapa-1.a1051596.png";